var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Back(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9246 3.70352C16.0295 3.80804 16.1127 3.93223 16.1695 4.06898C16.2263 4.20572 16.2555 4.35233 16.2555 4.5004C16.2555 4.64846 16.2263 4.79507 16.1695 4.93182C16.1127 5.06856 16.0295 5.19276 15.9246 5.29727L9.22245 11.9995L15.9246 18.7035C16.136 18.9149 16.2547 19.2015 16.2547 19.5004C16.2547 19.7993 16.136 20.0859 15.9246 20.2973C15.7133 20.5086 15.4266 20.6273 15.1278 20.6273C14.8289 20.6273 14.5422 20.5086 14.3309 20.2973L6.83089 12.7973C6.72601 12.6928 6.64279 12.5686 6.58601 12.4318C6.52923 12.2951 6.5 12.1485 6.5 12.0004C6.5 11.8523 6.52923 11.7057 6.58601 11.569C6.64279 11.4322 6.72601 11.308 6.83089 11.2035L14.3309 3.70352C14.4354 3.59864 14.5596 3.51543 14.6963 3.45864C14.8331 3.40186 14.9797 3.37263 15.1278 3.37263C15.2758 3.37263 15.4224 3.40186 15.5592 3.45864C15.6959 3.51543 15.8201 3.59864 15.9246 3.70352Z",
    fill: "#6B7380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Back);
export default __webpack_public_path__ + "static/media/24_back.d5bae5746c2c149e750568367892a60e.svg";
export { ForwardRef as ReactComponent };